import * as React from "react";
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Grid from "@mui/material/Grid";
import { Theme } from "@mui/material";
import Props from "./gridBase.d";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      display: "flex",
      flexGrow: 1,
      flexDirection: "row",
      // backgroundColor: theme.palette.background.paper
    },
    child: {
      display: "inherit",
      marginLeft: 30,
    },
  })
);
interface GFCFieldSet_Horizontal extends Props {
  children: React.ReactNode;
  container?: boolean;
  item?: boolean;
}

const FieldSetHorizontal: React.FC<GFCFieldSet_Horizontal> = (props) => {
  // @ts-ignore
  const { raftQuery, raftVariables, raftId, xs, flatTree, ...rest } = props;
  const classes = useStyles({});
  // @ts-ignore
  if (props.hidden) return null;
  return (
    <Grid xs={xs ?? true} {...rest}>
      {props.children}
    </Grid>
  );
};
export default FieldSetHorizontal;
